var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  staticClass: "flex-1",
                  attrs: {
                    multiple: "",
                    "collapse-tags": "",
                    clearable: "",
                    filterable: "",
                    placeholder: _vm.$t("pleaseSelectChannel")
                  },
                  on: { change: _vm.selectChange },
                  model: {
                    value: _vm.searchData.channel_list,
                    callback: function($$v) {
                      _vm.$set(_vm.searchData, "channel_list", $$v)
                    },
                    expression: "searchData.channel_list"
                  }
                },
                [
                  _c(
                    "el-checkbox",
                    {
                      on: { change: _vm.chanelChange },
                      model: {
                        value: _vm.channelChecked,
                        callback: function($$v) {
                          _vm.channelChecked = $$v
                        },
                        expression: "channelChecked"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("selectAll")))]
                  ),
                  _vm._l(_vm.channelList, function(item) {
                    return _c("el-option", {
                      key: item.id,
                      attrs: {
                        label: item.channel_name,
                        value: item.channel_mark
                      }
                    })
                  })
                ],
                2
              )
            ],
            1
          ),
          _c("dataScreening", {
            attrs: {
              propsData: {
                isProduct: false,
                isCountry: false,
                isDate: false,
                isCurrency: true
              }
            },
            on: {
              searchChange: _vm.searchChange,
              currencyChange: _vm.currencyChange
            }
          }),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-date-picker", {
                attrs: {
                  clearable: false,
                  "picker-options": _vm.pickerOptionsDay,
                  "value-format": "yyyy-MM-dd",
                  type: "date",
                  align: "right"
                },
                model: {
                  value: _vm.searchData.date,
                  callback: function($$v) {
                    _vm.$set(_vm.searchData, "date", $$v)
                  },
                  expression: "searchData.date"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20, type: "flex", justify: "end" } },
        [
          _c(
            "el-col",
            { staticStyle: { "text-align": "right" }, attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.reqLoading },
                  on: {
                    click: function($event) {
                      return _vm.searchClick(true)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("search")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { position: "relative", "margin-bottom": "50px" } },
        [
          _c(
            "div",
            {
              staticStyle: {
                position: "absolute",
                right: "0px",
                top: "10px",
                "z-index": "10"
              }
            },
            [
              _c(
                "span",
                {
                  staticStyle: {
                    "font-size": "14px",
                    "margin-right": "8px",
                    color: "#606266"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("switchChannel")) + ":")]
              ),
              _c(
                "el-select",
                {
                  attrs: {
                    placeholder: _vm.$t("pleaseSelectChannel"),
                    size: "small"
                  },
                  on: { change: _vm.handleChartChannelChange },
                  model: {
                    value: _vm.activeChartChannel,
                    callback: function($$v) {
                      _vm.activeChartChannel = $$v
                    },
                    expression: "activeChartChannel"
                  }
                },
                _vm._l(_vm.channelList, function(item) {
                  return _c("el-option", {
                    key: item.channel_mark,
                    attrs: {
                      label: item.channel_name,
                      value: item.channel_mark
                    }
                  })
                }),
                1
              )
            ],
            1
          )
        ]
      ),
      _c("div", {
        staticStyle: { height: "450px", "margin-bottom": "50px" },
        attrs: { id: "echartcollect" }
      }),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "small",
                    disabled: !_vm.tableData.length
                  },
                  on: { click: _vm.exportdata }
                },
                [_vm._v(_vm._s(_vm.$t("export")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "sticky-table-header",
              rawName: "v-sticky-table-header",
              value: 0,
              expression: "0"
            }
          ],
          attrs: { data: _vm.tableData, border: "" }
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "channel_mark",
              label: _vm.$t("channelId"),
              width: 100,
              frozen: ""
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "channel_name",
              label: _vm.$t("channelName"),
              width: 120,
              frozen: ""
            }
          }),
          _c(
            "el-table-column",
            { attrs: { prop: "hours", label: _vm.$t("time"), width: 100 } },
            [
              _c("template", { slot: "header" }, [
                _c(
                  "div",
                  { staticClass: "dateClasst" },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: {
                          opacity: "0",
                          position: "absolute",
                          left: "0",
                          top: "0"
                        },
                        attrs: { multiple: "", "collapse-tags": "" },
                        on: { change: _vm.screenChange },
                        model: {
                          value: _vm.screen,
                          callback: function($$v) {
                            _vm.screen = $$v
                          },
                          expression: "screen"
                        }
                      },
                      _vm._l(_vm.screenList, function(item, index) {
                        return _c("el-option", {
                          key: index,
                          attrs: { label: item.label, value: item.prop }
                        })
                      }),
                      1
                    ),
                    _c("div", { staticClass: "screenIconB" }, [
                      _c("img", {
                        staticClass: "screenIcon",
                        attrs: {
                          src: require("../../../assets/screenIcon.png"),
                          alt: ""
                        }
                      })
                    ])
                  ],
                  1
                ),
                _c("div", [_vm._v(_vm._s(_vm.$t("time")))])
              ])
            ],
            2
          ),
          _vm._l(_vm.tableDataList, function(item, index) {
            return _c("el-table-column", {
              key: index,
              attrs: {
                prop: item.prop,
                label: item.label,
                "min-width": item.width
              }
            })
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }